// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xIsStockedItemsOnly } from "@ces/App/Store/Selectors/GeneralSelectors";
import { parseBoolean } from "@ces/XDL/Utilities";
import { addToChainAfter, executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    GetUnfilteredProducts,
    ParseQueryParameter,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import qs from "qs";

export const XngPopulateApiParameter = (props: any) => {
    props.apiParameter = {
        ...props.apiParameter,
        expand: [...(props.apiParameter.expand || []), "properties"],
        // xng-change
        getCounts: true,
    };
};

export const XngGetUnfilteredProducts: typeof GetUnfilteredProducts = async props => {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);
    const { stockedItemsOnly } = parsedQuery;

    const unfilteredApiParameter = { ...props.apiParameter };
    delete (unfilteredApiParameter as any).clearance;
    delete (unfilteredApiParameter as any).instantRebate;
    delete unfilteredApiParameter.searchWithin;

    if (!props.result.productFilters.pageBrandId) {
        delete unfilteredApiParameter.brandIds;
    }
    if (!props.result.productFilters.pageProductLineId) {
        delete unfilteredApiParameter.productLineIds;
    }
    delete unfilteredApiParameter.priceFilters;
    delete unfilteredApiParameter.attributeValueIds;
    if (!props.result.productFilters.pageCategoryId) {
        delete unfilteredApiParameter.categoryId;
    }
    unfilteredApiParameter.stockedItemsOnly =
        xIsStockedItemsOnly(props.getState()) && (stockedItemsOnly === undefined || parseBoolean(stockedItemsOnly));
    unfilteredApiParameter.previouslyPurchasedProducts = undefined;

    props.result.unfilteredApiParameter = unfilteredApiParameter;
    props.result.filteredApiParameter = { ...props.apiParameter };

    const unfilteredProducts = getProductsDataView(props.getState(), unfilteredApiParameter).value;

    if (unfilteredProducts) {
        return;
    }

    await executeAwaitableHandlerChain(loadProducts, unfilteredApiParameter, props);
};

export const XngParseQueryParameter: typeof ParseQueryParameter = props => {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);
    const { clearance, instantRebate, stockedItemsOnly } = parsedQuery;

    if (clearance !== undefined) {
        (props.result.productFilters as any).clearance = true;
    }
    if (instantRebate !== undefined) {
        (props.result.productFilters as any).instantRebate = true;
    }

    props.result.productFilters = {
        ...props.result.productFilters,
        stockedItemsOnly:
            xIsStockedItemsOnly(props.getState()) && (stockedItemsOnly === undefined || parseBoolean(stockedItemsOnly)),
    };
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
addToChainAfter(chain, ParseQueryParameter, XngParseQueryParameter);
